import captionService from "CaptionService";
import type { CaptionRecord } from "./types";

export const changeBranchDepartment: CaptionRecord = {
  cancel: () => captionService.getString("831c1d0c-2903-4f15-8ea2-5bd48fb0c585", "Cancel"),
  confirm: () => captionService.getString("c4ebb753-23bc-483c-a187-3f099e3c38a5", "Confirm"),
};
